import { axios } from './get-axios';
import Axios, { AxiosRequestConfig } from "axios";
import { type BaseQueryFn } from '@reduxjs/toolkit/query/react';
import { ACCESS_TOKEN_KEY, getEnv } from '@src/core/config';
import { trackError } from '@src/core/sentry';

export const instance = Axios.create({
  baseURL: getEnv('REACT_APP_API_BASE_URL') + '/api/v1',
});


instance.interceptors.request.use((request: any) => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (token) {
    request.headers["Authorization"] = `Bearer ${token}`;
  }
  request.headers["Content-Type"] = "application/json";
  return request;
});


export const axiosBaseQuery = (): BaseQueryFn<
  {
    url: string
    method?: AxiosRequestConfig['method']
    data?: AxiosRequestConfig['data']
    params?: AxiosRequestConfig['params']
    responseType?: AxiosRequestConfig['responseType']
  }
> => async (arg) => {
  const { url, method = 'GET', data, params, responseType } = arg;
  try {
    const axiosData = await axios({ 
      url, 
      method, 
      data, 
      params,
      responseType: responseType || 'json'
    });
    return { data: axiosData.data };
  } catch (axiosError: unknown) {
    const ax = axiosError as {
      response?: { status?: number; data?: unknown };
      message?: string;
    };
    const status = ax?.response?.status;
    const responseData = ax?.response?.data ?? ax?.message;
    const pathForGroup = url.replace(/\/\d+/g, '/:id');

    trackError(axiosError instanceof Error ? axiosError : new Error(String(ax?.message ?? 'HTTP request failed')), {
      code: 'FE_0001',
      tags: {
        http_status: status != null ? String(status) : 'network',
      },
      extra: {
        url,
        method,
        status,
        responseData,
      },
      fingerprint: ['FE_0001', pathForGroup, String(status ?? 'none')],
    });

    return {
      error: {
        status,
        data: responseData,
      },
    };
  }
};





